import { render } from "./MfgPaintingProductionStatistics2.vue?vue&type=template&id=db8a2fd2&scoped=true"
import script from "./MfgPaintingProductionStatistics2.vue?vue&type=script&lang=js"
export * from "./MfgPaintingProductionStatistics2.vue?vue&type=script&lang=js"

import "./MfgPaintingProductionStatistics2.vue?vue&type=style&index=0&id=db8a2fd2&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db8a2fd2"]])

export default __exports__